export const stripRichText = (value?: string | null): string => {
  const source = String(value || '').trim()

  if (!source) return ''

  if (typeof window !== 'undefined' && 'DOMParser' in window) {
    const parser = new DOMParser()
    const document = parser.parseFromString(source, 'text/html')
    return (document.body.textContent || '')
      .replace(/\s+/g, ' ')
      .trim()
  }

  return source
    .replace(/<[^>]+>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
}
